<script setup lang="ts">
// PROPS
interface Props {
    appliedFilters: AppliedFilter[];
    /** One after the other, as the filters an interpreted search just set. */
    isAnimated?: boolean;
}

const { appliedFilters, isAnimated = false } = defineProps<Props>();
</script>

<template>
    <BaseDeletableBadge
        v-for="(filter, index) in appliedFilters"
        :key="index"
        color="primary"
        variant="soft"
        size="lg"
        :label="filter.label"
        :class="{ 'motion-safe:animate-ai-chip-in': isAnimated }"
        :style="isAnimated ? { animationDelay: `${index * 200}ms` } : undefined"
        @delete="filter.deleteHandler"
    />
</template>
